import React, { useEffect, useState } from "react";
import DashboardCard from "../../Components/Card/DashboardCard";
import { useSelector } from "react-redux";
import { CircularProgress, Grid, Button, Box } from "@mui/material";
import configServ from "../../services/config";
// icons
import PeopleIcon from "@mui/icons-material/People";
import DescriptionIcon from "@mui/icons-material/Description";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import BalanceIcon from "@mui/icons-material/Balance";
import { useNavigate } from "react-router-dom";
import CheckAndReturn from "../../utility/CheckAndReturn";
import FiberNewIcon from "@mui/icons-material/FiberNew";
// import GavelIcon from "@mui/icons-material/Gavel";
// import EventIcon from "@mui/icons-material/Event";
import BarGraph from "./BarGraph";
import VoiceCommand from "../../Components/VoiceRecognization/VoiceCommand ";
import InvoiceDashboardCharts from "../../Components/Graph/InvoiceLineGraph";
import AcUnitIcon from '@mui/icons-material/AcUnit';
import HearingDetails from "./HearingDetails";

//FUNCTION
function Dashboard() {
  //#region code
  const { user_id, company_id, companyName } = useSelector((state) => state.GlobalVariables);
  const navigate = useNavigate();

  const [count, setCount] = useState({});
  const [todayHearings, setTodayHearings] = useState([]);
  const [upcomingHearings, setUpcomingHearings] = useState([]);
  const [companyLogo, setCompanyLogo] = useState("");
  const [calendarData, setCalendarData] = useState([]);

  const fetchDashboardCount = async () => {
    try {
      const userId = user_id;
      if (userId === null) {
        navigate("/");
      }
      const dataToSend = {
        user_id: user_id,
        company_id: company_id,
      };
      const result = await configServ.getDashboardCount(dataToSend);
      setCount(result);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchDashboardCount();
  }, []);

  const cardData = [
    {
      title: "CUSTOMERS",
      number: count.subscription ?? <CircularProgress />,
      icon: <PeopleIcon sx={{ color: "#fb6340" }} />,
      link: "/account-master-entry/customers",
    },
    {
      title: "TOTAL CASES",
      number: count.total_cases ?? <CircularProgress />,
      icon: <DescriptionIcon sx={{ color: "#fb6340" }} />,
      link: "/create-case",
    },

    // Priority
    // {
    //   title: "LOW PRIORITY",
    //   number: count.priority?.low ?? <CircularProgress />,
    //   icon: <DescriptionIcon sx={{ color: "#fb6340" }} />,
    //   link: "/create-case",
    // },
    // {
    //   title: "MEDIUM PRIORITY",
    //   number: count.priority?.medium ?? <CircularProgress />,
    //   icon: <DescriptionIcon sx={{ color: "#fb6340" }} />,
    //   link: "/create-case",
    // },
    // {
    //   title: "HIGH PRIORITY",
    //   number: count.priority?.high ?? <CircularProgress />,
    //   icon: <DescriptionIcon sx={{ color: "#fb6340" }} />,
    //   link: "/create-case",
    // },
    // {
    //   title: "URGENT PRIORITY",
    //   number: count.priority?.urgent ?? <CircularProgress />,
    //   icon: <DescriptionIcon sx={{ color: "#fb6340" }} />,
    //   link: "/create-case",
    // },

    // Status
    {
      title: "ACTIVE",
      number: count.status?.active ?? <CircularProgress />,
      icon: <DescriptionIcon sx={{ color: "#fb6340" }} />,
      link: "/create-case",
    },
    {
      title: "PENDING",
      number: count.status?.pending ?? <CircularProgress />,
      icon: <DescriptionIcon sx={{ color: "#fb6340" }} />,
      link: "/create-case",
    },
    {
      title: "DISPOSED",
      number: count.status?.disposed ?? <CircularProgress />,
      icon: <DescriptionIcon sx={{ color: "#fb6340" }} />,
      link: "/create-case",
    },
    // {
    //   title: "CLOSED",
    //   number: count.status?.closed ?? <CircularProgress />,
    //   icon: <DescriptionIcon sx={{ color: "#fb6340" }} />,
    //   link: "/create-case",
    // },
    // {
    //   title: "ON HOLD",
    //   number: count.status?.on_hold ?? <CircularProgress />,
    //   icon: <DescriptionIcon sx={{ color: "#fb6340" }} />,
    //   link: "/create-case",
    // },

    // Hearings
    // {
    //   title: "TODAY'S HEARINGS",
    //   number: count.hearings?.today ?? <CircularProgress />,
    //   icon: <AcUnitIcon sx={{ color: "#fb6340" }} />,
    //   link: "/hearing",
    // },
    // {
    //   title: "NEXT 7 DAYS HEARINGS",
    //   number: count.hearings?.next_7_days ?? <CircularProgress />,
    //   icon: <AcUnitIcon sx={{ color: "#fb6340" }} />,
    //   link: "/hearing",
    // },
  ];


  const fetchTodayHearings = async (date) => {
    try {
      const dataToSend = {
        user_id: user_id,
        company_id: company_id,
        date: date || new Date().toISOString().split("T")[0], // Default to today's date if not provided
      };
      const result = await configServ.getTodayHearings(dataToSend);
      if (result.status) {

        setTodayHearings(result.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const fetchUpcomingHearings = async () => {
    try {
      const dataToSend = {
        user_id: user_id,
        company_id: company_id,
      };
      const result = await configServ.getUpcomingHearings(dataToSend);
      if (result.status) {
        setUpcomingHearings(result.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchTodayHearings();
    fetchUpcomingHearings();
  }, []);

  const assignCompanyLogo = async () => {
    try {
      const result = await configServ.company_logo({ company_id: company_id });
      if (result && result.image) {
        // Assuming the result.image is already a base64 string
        setCompanyLogo(`data:image/png;base64,${result.image}`);
      } else {
        setCompanyLogo(null); // Set as null if no logo
      }
    } catch (e) {
      console.log(e);
      setCompanyLogo(null); // Handle error by clearing logo
    }
  };

  useEffect(() => {
    assignCompanyLogo();
  }, []);


  const fetchCalendarHearings = async (payload) => {
    try {
      console.log("Fetching API for Payload:", payload);

      const result = await configServ.getHearingCalendarCount(payload);

      if (result.status) {
        setCalendarData(result.data);
      } else {
        setCalendarData([]);
      }
    } catch (error) {
      console.error("Failed to fetch calendar hearings:", error);
      setCalendarData([]);
    }
  };

  // Initial Load (Default current Month/Year)
  useEffect(() => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; // getMonth() 0-based hota hai (0 = Jan, 6 = July)
    const currentYear = currentDate.getFullYear();

    fetchCalendarHearings({
      company_id: company_id, // Agar company_id dynamic hai to yahan variable pass karein
      month: currentMonth,
      year: currentYear
    });
  }, []);

  const onDateSelect = (selectedDate) => {
    console.log("Selected Date:", selectedDate);
    fetchTodayHearings(selectedDate);

    // Aap yahan pe API call ya state update kar sakte hain based on the selected date
  }


  //#endregion

  return (
    <>
      <Grid
        container
        alignItems={"center"}
        justifyContent={"flex-start"}
        spacing={2}
        p={2}
        my={1}
        sx={{
          backgroundColor: "#6270e4",
          width: "100%",
        }}
      >
        {cardData.map((item, index) => (
          <DashboardCard index={index} data={item} onClick={item.onClick} />
        ))}
      </Grid>

      {/* Hearing Details Section */}
      <Box
        sx={{
          width: '100%',
          p: { xs: 1.5, sm: 2, md: 3 },
          my: 1
        }}
      >
        <HearingDetails
          companyName={companyName}
          todayHearingList={todayHearings}
          upcomingHearings={upcomingHearings}
          companyLogo={companyLogo}
          onMonthChange={(payload) => fetchCalendarHearings(payload)}
          calendarData={calendarData}
          onDateSelect={onDateSelect}      // Optional: Callback when user clicks a specific date

        />
      </Box>
    </>
  );
}

export default Dashboard;
